var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.$style.jobbookingView},[_c('Header',{attrs:{"title":_vm.$route.meta.title,"subtitle":_vm.$route.meta.subtitle}}),_c('div',{class:_vm.$style.main},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }